import { Instruction } from 'features/chat/types';
import { WellframeApi } from 'store/api';

export const instructionsService = WellframeApi.injectEndpoints({
  endpoints: (builder) => ({
    getInstructions: builder.query<Instruction[], void>({
      query: () => '/api/v2/patient_notes',
      providesTags: (result) =>
        result
          ? [...result.map(({ id }) => ({ type: 'Instruction' as const, id })), 'Instruction']
          : ['Instruction'],
    }),
    markInstructionAsRead: builder.mutation<void, number>({
      query: (instructionId) => ({
        url: `/api/v3/patient_notes/${instructionId}`,
        method: 'PATCH',
        body: { read_by_patient: true },
      }),
      invalidatesTags: (_result, _error, instructionId) => [
        { type: 'Instruction', id: instructionId },
      ],
    }),
  }),
});

export const { useGetInstructionsQuery, useMarkInstructionAsReadMutation } = instructionsService;
